<template>
  <div class="c-filter-tabs">
    <b-button-group class="c-filter-tabs__group">
      <v-button
        class="flex-fill c-filter-tabs__button"
        v-for="(tab, index) in filteredTabs"
        :key="index"
        :pressed="tab.pressed"
        @click="onTabSelected(tab, index)"
        >{{ $t(`${i18nNamespace}.${tab.name}`) }}
      </v-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  name: 'c-filter-tabs',
  props: {
    tabs: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredTabs() {
      return this.tabs;
    },
    i18nNamespace() {
      return 'white-label.components.filterTabs';
    }
  },
  methods: {
    onTabSelected(tab, index) {
      this.$emit('selected', { tab, index });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-filter-tabs';
</style>
